import { BASE_ROW_HEIGHT, GROUP_BY_HEIGHT } from "../../constants/height";

export const getResourceRowHeight = (resourceId: string, resourceLayouts: any): number => {
    const layout = resourceLayouts?.[resourceId];
    return layout ? layout.totalLanes * (layout?.type ? GROUP_BY_HEIGHT : BASE_ROW_HEIGHT) : BASE_ROW_HEIGHT;
};
